import { v4 as uuidv4 } from 'uuid';
import { CLIENT_ID, V2 } from '../constants/constants';
import { getEwpApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    tripId, bookingEmail, emailSubject,
    emailMessage, emailAddresses, bookingDate,
    serviceSelector, locale, enablePbccEmailForUS,
    correlationId, partnerName,
  }, action, state) => {
    const emails = emailAddresses?.map((element) => element?.trim());
    let requestPayload = {
      tripId,
      bookingEmail,
      emailSubject,
      emailMessage,
      emailAddresses: emails,
      partnerName,
    };
    /* enablePbccEmailForUS - PBCC EnabledDate check */
    if (locale !== 'en-US' || (locale === 'en-US' && enablePbccEmailForUS)) {
      requestPayload = {
        ...requestPayload,
        bookingDate,
        serviceSelector,
        locale,
      };
    }
    return {
      url: `${getEwpApiUrl(state)}/travel/v1/email/itinerary`, // url will remain same - no changes
      opts: {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-client-version': V2,
          'x-client-id': CLIENT_ID,
          'x-correlation-id': correlationId || uuidv4(),
        },
        body: JSON.stringify({ ...requestPayload }),
      },
    };
  },
};
